const tokenKey = 'packing_access_token';
export const getToken = () => localStorage.getItem(tokenKey);
export const setToken = (token: string) => localStorage.setItem(tokenKey, token);
export const removeToken = () => localStorage.removeItem(tokenKey);

const lastUserKey = 'packing_last_user';
export const getLastUser = () => localStorage.getItem(lastUserKey);
export const setLastUser = (username: string) => localStorage.setItem(lastUserKey, username);
export const removeLastUser = () => localStorage.removeItem(lastUserKey);

const currentLocationKey = 'packing_current_location';
export const getLocation = () => localStorage.getItem(currentLocationKey);
export const setLocation = (location: string) => localStorage.setItem(currentLocationKey, location);
export const removeLocation = () => localStorage.removeItem(currentLocationKey);
